import { shallowEqual,useDispatch, useSelector } from 'react-redux';

import { STATE_HISTORY_OPERATIONS } from 'store/searchFilter';
import { updateFiltersState } from 'store/searchFilter/actions';

export function useFilterState(filterGroup) {
  const dispatch = useDispatch();

  function append(newState) {
    dispatch(
      updateFiltersState({
        filterGroup: filterGroup,
        newState,
        operation: STATE_HISTORY_OPERATIONS.APPEND,
      })
    );
  }

  function reset() {
    dispatch(
      updateFiltersState({
        filterGroup: filterGroup,
        newState: {},
        operation: STATE_HISTORY_OPERATIONS.RESET,
      })
    );
  }

  function undo() {
    dispatch(
      updateFiltersState({
        filterGroup: filterGroup,
        newState: {},
        operation: STATE_HISTORY_OPERATIONS.UNDO,
      })
    );
  }

  const { queue, queueLength } = useSelector(
    ({ searchFilter }) => ({
      queue: searchFilter.stateHistory[filterGroup],
      queueLength: searchFilter?.stateHistory[filterGroup]?.length || 0,
    }),
    shallowEqual
  );

  // FRON-8381 | Last queue item is overwritten by empty object
  let queueLast = queueLength === 1 ? queue[0] : queueLength > 1 ? queue[queueLength - 1] : {};

  return {
    queue,
    queueLength,
    queueLast,
    append,
    undo,
    reset,
  };
}
